import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {FilterInput} from 'src/components/input';

import {groupsTabStateActions, groupsTabStateSelector} from '../slices/groups-tab-state.slice';

export const GroupNameFilter = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(groupsTabStateSelector);

    const changeGroupNameFilter = useCallback((name: string) => {
        dispatch(groupsTabStateActions.setFilters({name}));
    }, [dispatch]);

    const clearGroupNameFilter = useCallback(() => {
        dispatch(groupsTabStateActions.setFilters({}));
    }, [dispatch]);

    return (
        <FilterInput
            id="group-name-filter-input"
            value={cacheKeys.filters.name as string || ''}
            width={300}
            placeholder="Search for groups by name"
            onChange={changeGroupNameFilter}
            onClear={clearGroupNameFilter}
            timeOut={1500}
        />
    );
};
